"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawerContext = exports.DrawerContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_modern_drawer_1 = __importDefault(require("react-modern-drawer"));
var createUseContext_1 = require("../helpers/createUseContext");
require("react-modern-drawer/dist/index.css");
function useDrawerContextData() {
    var _a = react_1.default.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggleDrawer = function () {
        setIsOpen(function (prevState) { return !prevState; });
    };
    return (0, react_1.useMemo)(function () { return ({
        isOpen: isOpen,
        toggleDrawer: toggleDrawer,
    }); }, [isOpen]);
}
exports.default = useDrawerContextData;
function DrawerContextProvider(_a) {
    var children = _a.children, drawerContent = _a.drawerContent, _b = _a.direction, direction = _b === void 0 ? "right" : _b;
    var _c = useDrawerContextData(), isOpen = _c.isOpen, toggleDrawer = _c.toggleDrawer;
    return ((0, jsx_runtime_1.jsxs)(DrawerContext.Provider, __assign({ value: { isOpen: isOpen, toggleDrawer: toggleDrawer } }, { children: [(0, jsx_runtime_1.jsx)(react_modern_drawer_1.default, __assign({ open: isOpen, onClose: toggleDrawer, direction: direction, size: window.innerWidth * 0.3 }, { children: drawerContent })), children] })));
}
exports.DrawerContextProvider = DrawerContextProvider;
var DrawerContext = (0, react_1.createContext)(null);
DrawerContext.displayName = "DrawerContext";
exports.useDrawerContext = (0, createUseContext_1.createUseContext)(DrawerContext);
